<template>
    <b-modal id="add-award-icon-modal" title="Add award icon" body-bg-variant="white" body-class="bg-white"
             v-model="showAddAwardIcon" >
        <div v-for="awardIcon in availableAwardIcons">
            <input type="radio" id="one" :value="awardIcon.downloadUrl" v-model="picked">
            <img style="max-width:100px" :src="awardIcon.downloadUrl"/>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="secondary" @click="showAddAwardIcon = false">Close</b-button>
            <b-button variant="primary"  @click="()=>{pickIcon(picked);showAddAwardIcon = false}"
                      v-bind:disabled="picked == null">Save</b-button>
        </template>
    </b-modal>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import {firestore, } from "../../main";
  import Vue from "vue";
  import vSelect from "vue-select";

  export default {
    name: "AddAwardIcon",
    components: {vSelect},
    data(){
      return {
        showAddAwardIcon: false,
        popover: false,
        error: null,
        picked: null,
      }
    },
    computed: {
      ...mapState("awards", ["availableAwardIcons"]),
    },
    methods: {
      ...mapActions("awards", ["getAvailableAwardIcons", "pickIcon"]),
    },
    async mounted() {
      await this.getAvailableAwardIcons();
    }
  }
</script>

<style scoped>

</style>
